function getByPath(obj, path) {
    return path.reduce(
        (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
        obj
    );
}

function resolveTemplateName(item) {
    if (item && item.templateName) return item.templateName;
}

function normalizeServerItemToTemplate(item, mapping) {
    const id = String(item.id);
    const name = resolveTemplateName(item);

    const data = {};
    Object.keys(mapping).forEach((targetKey) => {
        const cfg = mapping[targetKey];
        const path = (cfg && cfg.path) || [];
        const transform = cfg && cfg.transform;
        const raw = getByPath(item, path);
        data[targetKey] =
            typeof transform === 'function'
                ? transform(raw, item)
                : raw !== null
                    ? raw
                    : null;
    });

    return { id, name, data };
}

async function loadTemplates(loadFn, fieldMapping) {
    const res = await loadFn();
    const raw = Array.isArray(res && res.data) ? res.data : [];
    return raw.map((item) => normalizeServerItemToTemplate(item, fieldMapping));
}

function applyTemplate(oldData, tplData, head) {
    const merged = { ...oldData, ...tplData };

    (head || []).forEach((field) => {
        if (field && typeof field.showIfDialog === 'function') {
            const wasVisible = field.showIfDialog(oldData);
            const nowVisible = field.showIfDialog(merged);
            if (wasVisible && !nowVisible) {
                merged[field.id] = null;
            }
        }
    });

    return merged;
}

const defaultFieldMapping = {
    gatewayId: { path: ['gateway', 'id'] },
    gatewayAccountId: { path: ['gatewayAccount', 'id'] },
    gatewaySettingId: { path: ['gatewaySetting', 'id'] },
    currency: { path: ['currency'] }
};

export const TemplateService = {
    loadTemplates,
    applyTemplate,
    defaultFieldMapping
};
